export default "__VITE_ASSET__c020ef6b__"